import { Dialog, DialogType } from '@fluentui/react';
import React from 'react';
import { IAlert } from '../../graphql/schema/p4types';
import { HeaderNotification } from './HeaderNotification';

export const BlockNotification = ({
  alertId,
  alert,
  dismiss,
}: {
  alertId?: string;
  alert: IAlert;
  dismiss: () => void;
}) => {
  return (
    <Dialog
      hidden={false}
      dialogContentProps={{
        type: DialogType.normal,
        closeButtonAriaLabel: 'Navigate',
        styles: { inner: { padding: '0px 13px 10px' } },
      }}
      minWidth={'450px'}
      styles={{
        main: {
          minHeight: '50px',
        },
      }}
    >
      <HeaderNotification
        alertId={alertId}
        alert={alert}
        dismiss={dismiss}
        styles={{ row: { margin: '0px', marginTop: '-24px' } }}
      />
    </Dialog>
  );
};
